// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile — light / dark (black & white friendly) */

.profile-page {
  --pf-bg: #f7f9fb;
  --pf-surface: #ffffff;
  --pf-ink: #191c1e;
  --pf-muted: #4a4455;
  --pf-faint: #6b7280;
  --pf-line: rgba(25, 28, 30, 0.1);
  --pf-line-strong: rgba(25, 28, 30, 0.16);
  --pf-accent: #191c1e;
  --pf-accent-text: #ffffff;
  --pf-danger: #b91c1c;
  --pf-danger-soft: rgba(185, 28, 28, 0.08);
  --pf-focus: #334155;
  --pf-shadow: 0 8px 28px rgba(25, 28, 30, 0.06);
  --pf-radius: 16px;
  --pf-radius-sm: 12px;

  width: 100%;
  max-width: 880px;
  margin: 0 auto;
  padding: 8px 0 48px;
  color: var(--pf-ink);
}

html.dark .profile-page {
  --pf-bg: #0f172a;
  --pf-surface: #1e293b;
  --pf-ink: #f1f5f9;
  --pf-muted: #94a3b8;
  --pf-faint: #64748b;
  --pf-line: rgba(255, 255, 255, 0.1);
  --pf-line-strong: rgba(255, 255, 255, 0.16);
  --pf-accent: #f1f5f9;
  --pf-accent-text: #0f172a;
  --pf-danger: #f87171;
  --pf-danger-soft: rgba(248, 113, 113, 0.12);
  --pf-focus: #cbd5e1;
  --pf-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);
}

.profile-page__header {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

@media (min-width: 720px) {
  .profile-page__header {
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
}

.profile-page__eyebrow {
  margin: 0 0 8px;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--pf-faint);
}

.profile-page__title {
  margin: 0;
  font-size: clamp(1.5rem, 2.4vw, 1.9rem);
  font-weight: 650;
  letter-spacing: -0.03em;
  color: var(--pf-ink);
}

.profile-page__subtitle {
  margin: 8px 0 0;
  max-width: 46ch;
  font-size: 0.95rem;
  line-height: 1.5;
  color: var(--pf-muted);
}

.profile-page__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;
}

.profile-page__btn:focus-visible {
  outline: 2px solid var(--pf-focus);
  outline-offset: 2px;
}

.profile-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.profile-page__btn--primary {
  background: var(--pf-accent);
  color: var(--pf-accent-text);
}

.profile-page__btn--ghost {
  background: var(--pf-surface);
  border-color: var(--pf-line-strong);
  color: var(--pf-ink);
}

.profile-page__btn--danger {
  background: var(--pf-danger-soft);
  border-color: transparent;
  color: var(--pf-danger);
}

.profile-page__card {
  background: var(--pf-surface);
  border: 1px solid var(--pf-line);
  border-radius: var(--pf-radius);
  box-shadow: var(--pf-shadow);
  padding: 20px;
}

@media (min-width: 720px) {
  .profile-page__card {
    padding: 28px;
  }
}

.profile-page__card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 22px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--pf-line);
}

.profile-page__card-icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: var(--pf-bg);
  border: 1px solid var(--pf-line);
  color: var(--pf-ink);
  flex-shrink: 0;
}

.profile-page__card-icon svg {
  width: 16px;
  height: 16px;
}

.profile-page__card-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 650;
  letter-spacing: -0.02em;
  color: var(--pf-ink);
}

.profile-page__card-desc {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--pf-muted);
}

.profile-page__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 720px) {
  .profile-page__grid {
    grid-template-columns: 1fr 1fr;
    gap: 18px;
  }
}

.profile-page__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-page__label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--pf-ink);
}

.profile-page__label svg {
  width: 13px;
  height: 13px;
  color: var(--pf-faint);
}

.profile-page__input {
  width: 100%;
  min-height: 44px;
  padding: 10px 14px;
  border-radius: var(--pf-radius-sm);
  border: 1px solid var(--pf-line-strong);
  background: var(--pf-bg);
  color: var(--pf-ink);
  font-size: 14px;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.profile-page__input::placeholder {
  color: var(--pf-faint);
}

.profile-page__input:focus {
  border-color: var(--pf-focus);
  box-shadow: 0 0 0 3px rgba(51, 65, 85, 0.15);
}

html.dark .profile-page__input:focus {
  box-shadow: 0 0 0 3px rgba(203, 213, 225, 0.18);
}

.profile-page__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--pf-line);
}

.profile-page__meta {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-top: 16px;
}

@media (min-width: 640px) {
  .profile-page__meta {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.profile-page__meta-item {
  padding: 12px 14px;
  border-radius: var(--pf-radius-sm);
  background: var(--pf-bg);
  border: 1px solid var(--pf-line);
}

.profile-page__meta-label {
  margin: 0;
  font-size: 11px;
  font-weight: 650;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--pf-faint);
}

.profile-page__meta-value {
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--pf-ink);
  word-break: break-word;
}

.profile-page__skel-title {
  height: 28px;
  width: min(240px, 60%);
  border-radius: 10px;
  background: var(--pf-line);
  margin-bottom: 10px;
}

.profile-page__skel-sub {
  height: 16px;
  width: min(360px, 80%);
  border-radius: 8px;
  background: var(--pf-line);
  opacity: 0.7;
  margin-bottom: 24px;
}

.profile-page__skel-card {
  height: 320px;
  border-radius: var(--pf-radius);
  background: var(--pf-surface);
  border: 1px solid var(--pf-line);
}
`, "",{"version":3,"sources":["webpack://./src/pages/user/ProfilePage.css"],"names":[],"mappings":"AAAA,oDAAoD;;AAEpD;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,yCAAyC;EACzC,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;EACjB,oBAAoB;;EAEpB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,2CAA2C;EAC3C,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,gGAAgG;AAClG;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,gCAAgC;EAChC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,8BAA8B;IAC9B,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;EACvC,wBAAwB;EACxB,oBAAoB;EACpB,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;AAClC","sourcesContent":["/* Profile — light / dark (black & white friendly) */\n\n.profile-page {\n  --pf-bg: #f7f9fb;\n  --pf-surface: #ffffff;\n  --pf-ink: #191c1e;\n  --pf-muted: #4a4455;\n  --pf-faint: #6b7280;\n  --pf-line: rgba(25, 28, 30, 0.1);\n  --pf-line-strong: rgba(25, 28, 30, 0.16);\n  --pf-accent: #191c1e;\n  --pf-accent-text: #ffffff;\n  --pf-danger: #b91c1c;\n  --pf-danger-soft: rgba(185, 28, 28, 0.08);\n  --pf-focus: #334155;\n  --pf-shadow: 0 8px 28px rgba(25, 28, 30, 0.06);\n  --pf-radius: 16px;\n  --pf-radius-sm: 12px;\n\n  width: 100%;\n  max-width: 880px;\n  margin: 0 auto;\n  padding: 8px 0 48px;\n  color: var(--pf-ink);\n}\n\nhtml.dark .profile-page {\n  --pf-bg: #0f172a;\n  --pf-surface: #1e293b;\n  --pf-ink: #f1f5f9;\n  --pf-muted: #94a3b8;\n  --pf-faint: #64748b;\n  --pf-line: rgba(255, 255, 255, 0.1);\n  --pf-line-strong: rgba(255, 255, 255, 0.16);\n  --pf-accent: #f1f5f9;\n  --pf-accent-text: #0f172a;\n  --pf-danger: #f87171;\n  --pf-danger-soft: rgba(248, 113, 113, 0.12);\n  --pf-focus: #cbd5e1;\n  --pf-shadow: 0 8px 28px rgba(0, 0, 0, 0.35);\n}\n\n.profile-page__header {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n@media (min-width: 720px) {\n  .profile-page__header {\n    flex-direction: row;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 20px;\n  }\n}\n\n.profile-page__eyebrow {\n  margin: 0 0 8px;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--pf-faint);\n}\n\n.profile-page__title {\n  margin: 0;\n  font-size: clamp(1.5rem, 2.4vw, 1.9rem);\n  font-weight: 650;\n  letter-spacing: -0.03em;\n  color: var(--pf-ink);\n}\n\n.profile-page__subtitle {\n  margin: 8px 0 0;\n  max-width: 46ch;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: var(--pf-muted);\n}\n\n.profile-page__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 18px;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease, opacity 0.15s ease;\n}\n\n.profile-page__btn:focus-visible {\n  outline: 2px solid var(--pf-focus);\n  outline-offset: 2px;\n}\n\n.profile-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.profile-page__btn--primary {\n  background: var(--pf-accent);\n  color: var(--pf-accent-text);\n}\n\n.profile-page__btn--ghost {\n  background: var(--pf-surface);\n  border-color: var(--pf-line-strong);\n  color: var(--pf-ink);\n}\n\n.profile-page__btn--danger {\n  background: var(--pf-danger-soft);\n  border-color: transparent;\n  color: var(--pf-danger);\n}\n\n.profile-page__card {\n  background: var(--pf-surface);\n  border: 1px solid var(--pf-line);\n  border-radius: var(--pf-radius);\n  box-shadow: var(--pf-shadow);\n  padding: 20px;\n}\n\n@media (min-width: 720px) {\n  .profile-page__card {\n    padding: 28px;\n  }\n}\n\n.profile-page__card-head {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 22px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--pf-line);\n}\n\n.profile-page__card-icon {\n  display: grid;\n  place-items: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  background: var(--pf-bg);\n  border: 1px solid var(--pf-line);\n  color: var(--pf-ink);\n  flex-shrink: 0;\n}\n\n.profile-page__card-icon svg {\n  width: 16px;\n  height: 16px;\n}\n\n.profile-page__card-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n  color: var(--pf-ink);\n}\n\n.profile-page__card-desc {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--pf-muted);\n}\n\n.profile-page__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 720px) {\n  .profile-page__grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 18px;\n  }\n}\n\n.profile-page__field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profile-page__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--pf-ink);\n}\n\n.profile-page__label svg {\n  width: 13px;\n  height: 13px;\n  color: var(--pf-faint);\n}\n\n.profile-page__input {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 14px;\n  border-radius: var(--pf-radius-sm);\n  border: 1px solid var(--pf-line-strong);\n  background: var(--pf-bg);\n  color: var(--pf-ink);\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.profile-page__input::placeholder {\n  color: var(--pf-faint);\n}\n\n.profile-page__input:focus {\n  border-color: var(--pf-focus);\n  box-shadow: 0 0 0 3px rgba(51, 65, 85, 0.15);\n}\n\nhtml.dark .profile-page__input:focus {\n  box-shadow: 0 0 0 3px rgba(203, 213, 225, 0.18);\n}\n\n.profile-page__actions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid var(--pf-line);\n}\n\n.profile-page__meta {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-top: 16px;\n}\n\n@media (min-width: 640px) {\n  .profile-page__meta {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n.profile-page__meta-item {\n  padding: 12px 14px;\n  border-radius: var(--pf-radius-sm);\n  background: var(--pf-bg);\n  border: 1px solid var(--pf-line);\n}\n\n.profile-page__meta-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 650;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--pf-faint);\n}\n\n.profile-page__meta-value {\n  margin: 4px 0 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--pf-ink);\n  word-break: break-word;\n}\n\n.profile-page__skel-title {\n  height: 28px;\n  width: min(240px, 60%);\n  border-radius: 10px;\n  background: var(--pf-line);\n  margin-bottom: 10px;\n}\n\n.profile-page__skel-sub {\n  height: 16px;\n  width: min(360px, 80%);\n  border-radius: 8px;\n  background: var(--pf-line);\n  opacity: 0.7;\n  margin-bottom: 24px;\n}\n\n.profile-page__skel-card {\n  height: 320px;\n  border-radius: var(--pf-radius);\n  background: var(--pf-surface);\n  border: 1px solid var(--pf-line);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
